import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import { Navbar } from './components/Navbar';
import { ThemeProvider } from './context/ThemeContext';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Work } from './components/Work';
import { Projects } from './components/Projects';
import { Footer } from './components/Footer';
import { Analytics } from '@vercel/analytics/react';


function App() {
  return (
    <ThemeProvider>
      <Box
        display="flex"
        flexDirection="column"
        minHeight="100%"
      >
        <Navbar />

          <Routes>
            <Route path="/" element={<Hero />} />
            <Route path="/about" element={<About />} />
            <Route path="/work" element={<Work />} />
            <Route path="/projects" element={<Projects />} />
          </Routes>

        <Footer />
      </Box>
      <Analytics />
    </ThemeProvider>
  );
}

export default App;
